module.exports = __webpack_public_path__ + "static/img/Brees-MostPassYds-Milestone-Selective.6e95b80.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Brees-MostPassYds-Milestone-Selective.gif
// module id = 8LNV
// module chunks = 1